import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface ConfirmOrgWriteDialogData {
  feature: string;
  orgName: string;
  orgId: string;
}

@Component({
  selector: "app-confirm-org-write-dialog",
  templateUrl: "./confirm-org-write-dialog.component.html",
  styleUrls: ["./confirm-org-write-dialog.component.scss"],
})
export class ConfirmOrgWriteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmOrgWriteDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmOrgWriteDialogData
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
